export interface PikkukuvanKoko {
  l: number
  k: number
}

// Portaat ovat tositelistan 82×110-pikkukuva kerrottuna näytön tiheydellä.
// Webin ja mobiilin pitää osua samoihin portaisiin, jotta sama kuva on
// välimuistissa yhtenä versiona — Dart-peili:
// flutter/lemonaid/lib/models/kuitit/pikkukuvan_koot.dart
export const PIKKUKUVAN_KOOT: readonly PikkukuvanKoko[] = [
  { l: 82, k: 110 },
  { l: 123, k: 165 },
  { l: 164, k: 220 },
  { l: 246, k: 330 },
  { l: 328, k: 440 },
]

const PERUSLEVEYS = PIKKUKUVAN_KOOT[0].l

export const valitsePikkukuvanKoko = (tiheys: number, leveys = PERUSLEVEYS): PikkukuvanKoko => {
  const tarve = Math.ceil(leveys * (tiheys > 0 ? tiheys : 1))
  return PIKKUKUVAN_KOOT.find(koko => koko.l >= tarve) ?? PIKKUKUVAN_KOOT[PIKKUKUVAN_KOOT.length - 1]
}

export const onSallittuPikkukuvanKoko = (l: number, k: number): boolean => PIKKUKUVAN_KOOT.some(koko => koko.l === l && koko.k === k)

const SUORAAN_PIKKUKUVAKSI_KELPAAVAT_PAATTEET = ['jpg', 'jpeg', 'png', 'webp', 'pdf']

// Sharp ei osaa lukea näitä, joten pikkukuva tehdään CloudConvertilla, mikä
// on hidasta ja maksullista. Siksi niitä käytetään kansikuvana vain, kun
// alkuperäinen odottaa vielä käsittelyä eikä renderöityä sivua ole.
const MUUNNETTAVAT_PIKKUKUVAN_PAATTEET = ['heic', 'heif', 'csv', 'xls', 'xlsx', 'docx']

export const onSuoraanPikkukuvaksiKelpaavaPaate = (paate: string): boolean => SUORAAN_PIKKUKUVAKSI_KELPAAVAT_PAATTEET.includes(paate.toLowerCase())

export const onMuunnettavaPikkukuvanPaate = (paate: string): boolean => MUUNNETTAVAT_PIKKUKUVAN_PAATTEET.includes(paate.toLowerCase())

export const onPikkukuvaksiKelpaavaPaate = (paate: string): boolean => onSuoraanPikkukuvaksiKelpaavaPaate(paate) || onMuunnettavaPikkukuvanPaate(paate)

export const kelpaakoAlkuperainenKansikuvaksi = (paate: string, kasitelty: boolean): boolean => onSuoraanPikkukuvaksiKelpaavaPaate(paate) || (!kasitelty && onMuunnettavaPikkukuvanPaate(paate))
